module.exports = __webpack_public_path__ + "img/9.66afe200.png";